import { useMutation } from '@tanstack/react-query';
import type { IFileCsvParams } from 'api/resources/1099CSVFile';
import { get1099FileCSV } from 'api/resources/1099CSVFile';

export const useGet1099CSVFile = () =>
	useMutation({
		mutationFn: (params: IFileCsvParams) => get1099FileCSV(params),
	});
